import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

import {
  NgxAnalytics,
  NgxAnalyticsOnModule,
  NgxAnalyticsSettings,
  ANGULARTICS2_TOKEN,
  RouterlessTracking,
} from 'ngx-analytics';


export class NgxAnalyticsRouterlessModule {
  static forRoot(
    providers: Provider[],
    settings: Partial<NgxAnalyticsSettings> = {},
  ): ModuleWithProviders {
    return {
      ngModule: NgxAnalyticsRouterlessModule,
      providers: [
        { provide: ANGULARTICS2_TOKEN, useValue: { providers, settings } },
        RouterlessTracking,
        NgxAnalytics,
        ...providers,
      ],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [NgxAnalyticsOnModule],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
